import { GDFPalletCode, GDFRecord, GDFRecordType } from '../../gdf/type';
import palettes from '../../palettes/palettes';
import CustomDrawTooltip from './components/CustomDrawTooltip';
import DiversionTooltip from './components/DiversionTooltip';
import FaaDelayTooltip from './components/FaaDelayTooltip';
import FcaTooltip from './components/FcaTooltip';
import HotPolyHiTooltip from './components/HotPolyHiTooltip';
import HotPolyTooltip from './components/HotPolyTooltip';
import IataTurbulenceTooltip from './components/IataTurbulenceTooltip';
import MetarTooltip from './components/MetarTooltip';
import Pirep2Tooltip from './components/Pirep2Tooltip';
import PirepTooltip from './components/PirepTooltip';
import RvrTooltip from './components/RvrTooltip';
import TafTooltip from './components/TafTooltip';
import TapsTooltip from './components/TapsTooltip';
import TcfTooltip from './components/TcfTooltip';
import TfrTooltip from './components/TfrTooltip';
import WmoCatTooltip from './components/WmoCatTooltip';
import WmoCloudTooltip from './components/WmoCloudTooltip';
import WmoVolcano2Tooltip from './components/WmoVolcano2Tooltip';
import WmoVolcanoTooltip from './components/WmoVolcanoTooltip';
import { TooltipFromRaster } from './RasterTooltip';

export function TooltipFromFeature(props: { productId: number; palette: GDFPalletCode; item: GDFRecord }) {
    const { item, palette } = props;

    if (item.type === GDFRecordType.metar) {
        return <MetarTooltip record={item} />;
    } else if (item.type === GDFRecordType.taf) {
        return <TafTooltip record={item} />;
    } else if (item.type === GDFRecordType.ccfp) {
        return <TcfTooltip small={true} record={item} />;
    } else if (item.type === GDFRecordType.delay) {
        return <FaaDelayTooltip record={item} />;
    } else if (item.type === GDFRecordType.rvr) {
        return <RvrTooltip record={item} />;
    } else if (item.type === GDFRecordType.diversion) {
        return <DiversionTooltip record={item} />;
    } else if (item.type === GDFRecordType.pirep2) {
        return <Pirep2Tooltip record={item} />;
    } else if (item.type === GDFRecordType.pirep) {
        return <PirepTooltip record={item} />;
    } else if (item.type == GDFRecordType.fca) {
        return <FcaTooltip record={item} />;
    } else if (item.type === GDFRecordType.hotpoly && palette === GDFPalletCode.tfr) {
        if (!item.reduced) {
            return <TfrTooltip record={item} />;
        }
    } else if (item.type === GDFRecordType.hotpoly) {
        if (!item.reduced) {
            return <HotPolyTooltip record={item} />;
        }
    } else if (item.type === GDFRecordType.hotpolyhi) {
        if (item.reduced) {
            return <TooltipFromRaster palette={palettes[palette]} value={item.severity} />;
        } else {
            return <HotPolyHiTooltip record={item} />;
        }
    } else if (item.type === GDFRecordType.custom) {
        return <CustomDrawTooltip record={item} />;
    } else if (item.type === GDFRecordType.iataturb) {
        return <IataTurbulenceTooltip record={item} />;
    } else if (item.type === GDFRecordType.wmovolcano) {
        return <WmoVolcanoTooltip record={item} />;
    } else if (item.type === GDFRecordType.wmovolcano2) {
        return <WmoVolcano2Tooltip record={item} />;
    } else if (item.type === GDFRecordType.taps) {
        return <TapsTooltip record={item} />;
    } else if (item.type === GDFRecordType.wmocloud) {
        return <WmoCloudTooltip record={item} />;
    } else if (item.type === GDFRecordType.wmocat) {
        return <WmoCatTooltip record={item} />;
    }

    if (import.meta.env.DEV) {
        return (
            <>
                No tooltip for: {GDFRecordType[item.type]} ({item.type})
            </>
        );
    }

    return <></>;
}
